import React from "react";
import PropTypes from "prop-types";
// Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import ResponsiveImage from "../responsive-image/ResponsiveImage";
const useStyles = makeStyles(() => ({
  contentContainer: {
    marginLeft: 40
  },
  subHeaderContent: {
    marginTop: 25
  },
  imageStyles: {
    maxWidth: "100%"
  }
}));
const BrandLearningHeader = ({
  content
}) => {
  const classes = useStyles();
  const noImageUrl = content.images[0].url !== "";
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    xs: 11,
    md: 11,
    lg: 11,
    sm: 11,
    alignItems: "center"
  }, noImageUrl && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 2,
    xs: 3,
    container: true,
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(ResponsiveImage, {
    imageStyles: classes.imageStyles,
    images: content.images,
    imageAlt: "brand-learning-logo"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    lg: 5,
    xs: 6,
    className: noImageUrl ? classes.contentContainer : ""
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    color: "textPrimary"
  }, content.header), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textPrimary",
    className: classes.subHeaderContent
  }, content.subHeader)));
};
BrandLearningHeader.propTypes = {
  content: PropTypes.object.isRequired
};
export default BrandLearningHeader;